<!-- ErrorMessage.vue -->
<template>
  <div class="alert-container">
    <transition name="slide-down">
      <div class="alert alert-danger alert-dismissible" role="alert" v-if="displayError">
        <slot></slot>
        <button class="close" @click="$emit('dismiss-alert')" data-dismiss="alert" aria-label="Close">
          <i class="nc-icon-glyph ui-1_simple-remove" aria-hidden="true"></i>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ErrorMessage",
  data() {
    return {
      displayError: false,
    };
  },
  mounted() {
    // Use $nextTick to apply animation after rendering
    this.$nextTick(() => {
      this.displayError = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.alert-container {
  position: sticky !important;
  display: flex;
  justify-content: center;
  margin: 0;
  z-index: 1;
  top: 0px;

  .alert {
    width: 100%;
    position: relative;
    margin-bottom: 1rem;
    border-radius: 0;
    border: 0;
    margin: 0;
    font-size: 15px;
    font-family: var(--micrositeTypeStyle);
  }
  .alert-danger {
    background-color: $error-bg;
    color: $white;
  }
  button.close {
    opacity: 1 !important;
    background: none;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.8rem 1rem;
  }

  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: opacity 0.5s, max-height 0.5s;
  }

  /* .slide-down-leave-active in <2.1.8 */
  .slide-down-enter,
  .slide-down-leave-to {
    opacity: 0;
    max-height: 0;
  }
}

.alert-container button.close i.nc-icon-glyph {
  font-size: 21px;
  line-height: 26px;
  font-weight: lighter;
}
</style>
